<template>
  <el-dialog
    title="选择标签"
    :visible="visible"
    :before-close="handleCloseDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    width="800px"
  >
    <el-radio-group v-model="tag">
            <el-radio
              v-for="item in tagData"
              :key="item.uid"
              :label="item.uid"
              @click.native.prevent="radioClick(item.uid)">
              {{ item.name }}
            </el-radio>
    </el-radio-group>
    <div style="text-align: center; margin-top: 10px;">
        <el-button style="margin-right: 20px;" @click="handleCloseDialog">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
  </el-dialog>
</template>

<script>
import api from "@/services/api/customer";
import services from '~api/compact';

export default {
  data() {
    return {
      visible: false,
      tagData: [],
      tag: '',
      list: [], // 选中的医生
    }
  },
  mounted() {
      this.handleGetTagList()
  },
  methods: {
    // 获取字典
    async handleGetTagList() {
      const { data } = await services.apiGetCategoryData({ code: 'category_yybq' })
      this.tagData = data.results
    },
    open(list) {
      this.visible = true
      this.list = list
      if(list.length===1){
          const lableNames = list[0].lableNames
          const tagItem = this.tagData.find(ele=>ele.name===lableNames)
          this.tag = tagItem? tagItem.uid: ''
      }
    },
    handleCloseDialog() {
      this.visible = false
      this.tag = ''
      this.list = []
    },
    radioClick(e) {
        e === this.tag ? (this.tag = '') : (this.tag = e)
    },
    async handleSubmit() {
      try {
        const param = {
          customerUidList: this.list.map(ele => ele.uid),
          lableIdList: this.tag? [this.tag] : [],
        }
        await api.apiImportCustomer(param)
        this.$message({
          type: 'success',
          message: '操作成功!',
        });
        this.handleCloseDialog()
        this.$emit('success')
      } catch (e) {
        console.log(e)
      }
    },
  },
}
</script>
